import MapRepository from "../../../map/interfaces/gateways/map.repository"

export default class GetCurrentLocationCase {
  constructor (
    private readonly mapRepository: MapRepository
  ) {
  }

  async execute (): Promise<void> {
    return new Promise((resolve, reject) => {
      const mapRepo = this.mapRepository
      try {
        navigator.geolocation.getCurrentPosition(function (position) {
          console.log("Latitude is :", position.coords.latitude);
          console.log("Longitude is :", position.coords.longitude);
          mapRepo.setLocation(position.coords.latitude, position.coords.longitude)
          resolve()
        }, (error) => {
          console.error(error)
          resolve()
        })
      } catch (e) {
        console.log(e)
        console.error(e)
        resolve()
      }
    })
  }
}
